/**
 * 메시지 핸들러 콜백 종류
 */
export const CallbackKind = {
    UNKNOWN: 0,
    DATA: 1,
    ERROR: 2,
};